var a=function(a,s){return null===a||(a.classList?a.classList.add(s):a.className+=" ".concat(s)),a};export{a as default};
//# sourceMappingURL=addClass.mjs.map
